import { CalculateFunction } from 'interfaces/constants/CalculateModalConfig';
import { calculateModalConfigs } from 'utils/constants/calculateModalConfig';

export type DependencyMapItem = {
  dependentField: string;
  calculate: CalculateFunction;
};

type DependencyMap = {
  [key: string]: {
    keys: DependencyMapItem[];
    labels: string[];
  };
};

type TempMap = {
  [key: string]: {
    keys: Map<string, DependencyMapItem>;
    labels: Set<string>;
  };
};

export const getDependencyMap = () => {
  const tempMap: TempMap = {};

  const ensureField = (fieldName: string) => {
    if (!tempMap[fieldName]) {
      tempMap[fieldName] = {
        keys: new Map(),
        labels: new Set()
      };
    }
    return tempMap[fieldName];
  };

  const addDependency = (
    fieldName: string,
    dependentField: string,
    calculate: CalculateFunction,
    label: string
  ) => {
    const field = ensureField(fieldName);
    field.keys.set(dependentField, { dependentField, calculate });
    field.labels.add(label);
  };

  Object.entries(calculateModalConfigs).forEach(([configKey, config]) => {
    config.fields.forEach(field => {
      if (config.multipleCalculatedFields) {
        config.multipleCalculatedFields.forEach(calculatedField => {
          addDependency(
            field.name,
            calculatedField.name,
            calculatedField.calculate,
            calculatedField.fieldTitle || config.title
          );
        });
      }

      if (field.children) {
        const { fields, calculate } = field.children;
        fields.forEach(childField => {
          if (field.label)
            addDependency(childField.name, field.name, calculate, field.label);
        });
      }
    });
  });

  const dependencyMap: DependencyMap = {};
  Object.keys(tempMap).forEach(key => {
    dependencyMap[key] = {
      keys: Array.from(tempMap[key].keys.values()),
      labels: Array.from(tempMap[key].labels)
    };
  });

  return dependencyMap;
};

export const DEPENDENCY_MAP = getDependencyMap();
